import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入一级路由
import page1 from "../view/page1";
import page2 from "../view/page2";
import page3 from "../view/page3";
import page4 from "../view/page4";

import dashboard from "../dashboard";
Vue.use(VueRouter)

const routes = [
  {
    path: '/page1',
    name: 'page1',
    component: page1,
  },
  {
    path: '/page2',
    name: 'page2',
    component: page2,
  },
  {
    path: '/page3',
    name: 'page3',
    component: page3,
  },
  {
    path: '/page4',
    name: 'page4',
    component: page4,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
  },
  {
    path: '/',
    name: 'dashboard',
    component: dashboard,
  },
]


const router = new VueRouter({
  routes
})



export default router